import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BrandingActionsContext = /*#__PURE__*/createContext(undefined);
export function BrandingActionsProvider(props) {
  const {
    children,
    onToggleBrandSetup
  } = props;
  const value = {
    onToggleBrandSetup
  };
  return /*#__PURE__*/_jsx(BrandingActionsContext.Provider, {
    value: value,
    children: children
  });
}
export function useBrandingActions() {
  const context = useContext(BrandingActionsContext);
  if (!context) throw new Error('useBrandingActions must be used within a BrandingActionsProvider');
  return context;
}